module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid rtl"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title rtl"
  }, [_vm._v("סרטים לפרויקט \"" + _vm._s(_vm.category.name) + "\"")])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "search",
      "placeholder": "חפש"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keyup": function($event) {
        return _vm.callList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 table-responsive addSomePadding"
  }, [_c('table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.list), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.ceil(item.total_words / 250)))]), _vm._v(" "), _c('td', {
      staticClass: "nowarp"
    }, [_c('button', {
      staticClass: "downloadButton",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.downloadJson(item.id, item.name, 'txtspk')
        }
      }
    }, [_vm._v("Avid Speakers")]), _vm._v(" "), _c('button', {
      staticClass: "downloadButton",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.downloadJson(item.id, item.name, 'txt')
        }
      }
    }, [_vm._v("Avid Locators")]), _vm._v(" "), _c('button', {
      staticClass: "downloadButton",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.downloadJson(item.id, item.name, 'txtsrt')
        }
      }
    }, [_vm._v("Avid Subcap")]), _vm._v(" "), _c('button', {
      staticClass: "downloadButton",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.downloadJson(item.id, item.name, 'srt')
        }
      }
    }, [_vm._v("SRT")]), _vm._v(" "), _c('button', {
      staticClass: "downloadButton",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.downloadJson(item.id, item.name, 'docx')
        }
      }
    }, [_vm._v("Word")]), _vm._v(" "), _c('button', {
      staticClass: "downloadButton",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.downloadJson(item.id, item.name, 'odt')
        }
      }
    }, [_vm._v("OpenOffice")])]), _vm._v(" "), _c('td', {
      staticClass: "nowarp"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.edit(item)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v("\n                   \n                  "), _c('a', {
      staticClass: "text-danger",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.remove(item.id)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-remove",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "text-center col-md-12",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.callList
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push({
          name: 'home'
        })
      }
    }
  }, [_vm._v("חזור לפרוייקטים")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.add({
          id: 0,
          name: '',
          interviewer: ''
        })
      }
    }
  }, [_vm._v("הוסף סרט")])])])])]), _vm._v(" "), (_vm.obj != null) ? _c('div', {
    staticClass: "popupForm"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title",
    domProps: {
      "textContent": _vm._s(_vm.addEditTitle)
    }
  }, [_vm._v("Save Video")])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid addSomePadding"
  }, [_c('div-vali', {
    staticClass: "col-md-12 rtl",
    attrs: {
      "errorVee": _vm.errors.has('file'),
      "labelTxt": "קובץ JSON"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.getFileRequired()),
      expression: "getFileRequired()"
    }],
    ref: "file",
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "name": "file"
    },
    on: {
      "change": function($event) {
        return _vm.handleFileUpload()
      }
    }
  })]), _vm._v(" "), _c('div-vali', {
    staticClass: "col-md-12",
    attrs: {
      "errorVee": _vm.errors.has('name'),
      "labelTxt": "שם סרט"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.name),
      expression: "obj.name"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name",
      "data-vv-rules": "required"
    },
    domProps: {
      "value": (_vm.obj.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.obj, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div-vali', {
    staticClass: "col-md-12",
    attrs: {
      "errorVee": _vm.errors.has('interviewer'),
      "labelTxt": "מרואיין"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.interviewer),
      expression: "obj.interviewer"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "interviewer",
      "data-vv-rules": "required"
    },
    domProps: {
      "value": (_vm.obj.interviewer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.obj, "interviewer", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel()
      }
    }
  }, [_vm._v("בטל")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v("שמור")])])], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("שם")]), _vm._v(" "), _c('th', [_vm._v("מילים")]), _vm._v(" "), _c('th', [_vm._v("הורד")]), _vm._v(" "), _c('th', [_vm._v("כלים")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b60a8814","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Video.vue
// module id = 208
// module chunks = 1